import { useEffect, useState } from 'react';
import axios from 'axios';
import { MessageCircle, X } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const DEFAULTS = {
  whatsapp_number: '6281290008800',
  whatsapp_message:
    'Halo PowerX, saya ingin bertanya tentang produk UPS / inverter.',
};

export default function WhatsAppFab() {
  const [open, setOpen] = useState(false);
  const [visible, setVisible] = useState(false);
  const [cfg, setCfg] = useState(DEFAULTS);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 1200);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    axios
      .get(`${API}/api/site/config`)
      .then((r) => {
        if (r.data?.whatsapp_number)
          setCfg({
            whatsapp_number: r.data.whatsapp_number,
            whatsapp_message: r.data.whatsapp_message || DEFAULTS.whatsapp_message,
          });
      })
      .catch(() => {});
  }, []);

  const waUrl = `https://wa.me/${cfg.whatsapp_number}?text=${encodeURIComponent(
    cfg.whatsapp_message
  )}`;

  return (
    <div
      data-testid="whatsapp-fab"
      className={`fixed z-[60] bottom-5 right-5 md:bottom-7 md:right-7 transition-all duration-500 ${
        visible
          ? 'opacity-100 translate-y-0'
          : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
    >
      {open && (
        <div
          data-testid="whatsapp-fab-panel"
          className="mb-3 w-[280px] bg-white rounded-2xl shadow-2xl border border-neutral-200 overflow-hidden animate-in fade-in slide-in-from-bottom-2"
        >
          <div className="bg-neutral-950 text-white px-5 py-4 flex items-center justify-between">
            <div>
              <p className="text-[10px] tracking-[0.25em] text-red-400 font-semibold">
                POWERX SUPPORT
              </p>
              <p className="font-display font-bold text-sm">Online sekarang</p>
            </div>
            <button
              onClick={() => setOpen(false)}
              aria-label="Tutup"
              data-testid="whatsapp-fab-close"
              className="text-neutral-400 hover:text-white"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
          <div className="p-5">
            <p className="text-sm text-neutral-700 leading-relaxed mb-4">
              Halo! Ada yang bisa kami bantu? Tim sales kami siap menjawab di
              WhatsApp dengan respon &lt; 30 menit.
            </p>
            <a
              href={waUrl}
              target="_blank"
              rel="noreferrer"
              data-testid="whatsapp-fab-start-chat"
              className="inline-flex items-center justify-center gap-2 w-full bg-green-600 hover:bg-green-700 text-white text-sm font-semibold py-3 rounded-full transition-colors"
            >
              <MessageCircle className="w-4 h-4" />
              Mulai Chat
            </a>
          </div>
        </div>
      )}

      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="whatsapp-fab-toggle"
        aria-label="Chat WhatsApp PowerX"
        className="relative group flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-green-600 hover:bg-green-700 text-white shadow-xl shadow-green-600/30 transition-all hover:scale-105"
      >
        <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-40" />
        <MessageCircle className="relative w-7 h-7 md:w-8 md:h-8" />
      </button>
    </div>
  );
}
